import { call, put, select, takeEvery } from "redux-saga/effects";

import { ApiService, QRAuthTokenPOST } from "pwapi";

import {
  QR_LOGIN_CREATE_SUCCESS,
  QR_LOGIN_CREATE_ERROR,
  QR_LOGIN_CREATE_REQUEST,
} from "shared/actions/constants";
import { AuthState } from "shared/reducers/authReducer";

function* createBadge(action: any): any {
  const user_id = yield select(
    ({ auth }: { auth: AuthState }) => auth?.user?.id
  );

  try {
    const requestBody: QRAuthTokenPOST = {
      lab_id: action.payload.lab_id,
      user_id,
      pin: `1111`,
    };
    const c = yield call(ApiService.createQrAuthToken, {
      requestBody,
    });
    yield put({
      type: QR_LOGIN_CREATE_SUCCESS,
      payload: c,
    });
  } catch (e) {
    yield put({
      type: QR_LOGIN_CREATE_ERROR,
      payload: e,
    });
  }
}

export function* qrLoginSaga() {
  yield takeEvery(QR_LOGIN_CREATE_REQUEST, createBadge);
}
